import { SvgIcon, useTheme } from "@mui/material";
import type React from "react";
import { useState } from "react";
import { tileTextStyle } from "./style.ts";

const Collectibles: React.FC<{ selected: boolean }> = ({ selected }) => {
	const [hovered, setHovered] = useState(false);
	const theme = useTheme();
	const idleBackground = theme.palette.secondary.main;
	const hoverBackground = theme.palette.secondary.light;
	const selectedBackGround = theme.palette.info.main;

	const backGroundColor = selected ? selectedBackGround : hovered ? hoverBackground : idleBackground;
	return (
		<SvgIcon
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			viewBox="0 0 460 259"
			sx={{ width: "100%", height: "auto" }}
		>
			<defs>
				<style>{".cls-2{stroke-miterlimit:10;fill:none;stroke:#fff}"}</style>
			</defs>
			<g id="pozadi-boxu">
				<path
					id="pozadi"
					d="M0 0h460v259H0z"
					style={{
						fill: backGroundColor,
					}}
				/>
			</g>
			<g id="ilustrace">
				<path
					id="Vrstva_2"
					d="M460 237.2H0"
					style={{
						stroke: "#fff",
						fill: "none",
					}}
				/>
				<g
					id="pozemky"
					style={{
						clipPath: "url(#clip-path)",
					}}
				>
					<path
						d="M403.1 126.1c2.9 0 5.2-2.3 5.2-5.2s-2.3-5.2-5.2-5.2-5.2 2.3-5.2 5.2 2.3 5.2 5.2 5.2Z"
						className="cls-2"
					/>
					<circle cx={393} cy={103.4} r={2.5} className="cls-2" />
					<circle cx={413.3} cy={103.4} r={2.5} className="cls-2" />
					<path
						d="M386 92.6h34.3c1.7 0 3.1 1.4 3.1 3.1v32.9c0 1.7-1.4 3.1-3.1 3.1H386c-1.7 0-3.1-1.4-3.1-3.1V95.7c0-1.7 1.4-3.1 3.1-3.1ZM401.6 259v-52.9M401.6 168.1v-36.5M405.3 259v-52.9M405.3 168.1v-36.5M423.5 59.2l1.6-4.1-4.2-1.1-17.4 8.7L386 54l-4.2 1.1 1.6 4.1 13.5 6.7-13.5 6.7-1.6 4.1 4.2 1.2 17.5-8.7 17.4 8.7 4.2-1.2-1.6-4.1-13.5-6.7 13.5-6.7zM391 168.1h25.1v38H391z"
						className="cls-2"
					/>
					<path
						d="M393 108.6c2.9 0 5.2-2.3 5.2-5.2s-2.3-5.2-5.2-5.2-5.2 2.3-5.2 5.2 2.3 5.2 5.2 5.2ZM413.3 108.6c2.9 0 5.2-2.3 5.2-5.2s-2.3-5.2-5.2-5.2-5.2 2.3-5.2 5.2 2.3 5.2 5.2 5.2ZM401.6 79.9v12.7M405.3 79.9v12.7M403.5 72.5l-20.1 10-1.6 4 4.2 1.2 17.5-8.7 17.4 8.7 4.2-1.2-1.6-4-20-10zM385.2 75.1l36.5-18.4"
						className="cls-2"
					/>
					<path
						d="m385.2 84.9 18.3-9.2 18.2 9.2M421.7 75.1l-36.5-18.4M389.7 188.9c.5-.6.9-1.1 1.3-1.7v14.5c-.7.6-1.4 1.1-2.1 1.6-3.3 2.4-7.6 3.2-13.5 3.6h-3.3l-10.9-.3-25.9-.6-25.2-.6-23.8-.6-25.2-.6-23.1-.5-23.8-.6-22.9-.5-23.9-.6-28.1-.7v-5.6l28.1-.2h23.9c0-.1 69.7-.6 69.7-.6l48.9-.3 51-.3h15.2s8.4.5 13.3-5.7ZM420.9 168.1h14.6v22h-14.6zM167.6 195.7v6.4M191.5 195.5v7.2M214.4 195.4v7.8M238.2 195.3v8.5M261.2 195.1v9.2M286.4 195v9.9M310.2 194.8v10.7M335.3 194.7v11.4M361.2 194.5v12.2M416.1 174h4.7v10h-1.1s-1.5-.1-3.6 0v-10ZM435.5 174h3.1v10h-3.1z"
						className="cls-2"
					/>
				</g>
			</g>
			<text
				id="texty"
        style={tileTextStyle}
				transform="translate(20 44.289)"
			>
				Sběratelství
			</text>
		</SvgIcon>
	);
};

export default Collectibles;
